import styled from 'styled-components';
import {Space} from "antd";

const StyledMissingErpTabIcon = styled.div`
  align-items: center;
  display: flex;

  &.external-link-icon {
    svg {
      height: 12px;
      width: 12px;
    }
  }

  &:hover {
    svg {
      path {
        fill: ${props => props.theme.colors.neutral_9};
      }
    }
  }

  svg {
    height: 16px;
    width: 16px;
    path {
      fill: ${props => props.theme.colors.neutral_7};
      transition: .2s ease;
    }
  }
`;

const StyledMissingErpTabIconsSpace = styled(Space)`
  & > .ant-space-item {
    align-items: center;
    display: flex;
  }
`;

export {
  StyledMissingErpTabIcon,
  StyledMissingErpTabIconsSpace
}
